import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CTAButton } from './CTAButton';
const bonuses = [{
  id: 1,
  emoji: '📓',
  title: '"Mi Diario de Manifestación"',
  value: 17,
  desc: 'Tu espacio sagrado y personal para sembrar tus intenciones cada día. Porque lo que escribes con claridad y emoción... el universo lo escucha. Este diario te dará estructura, dirección y un ritual diario que convierte cada mañana en una oportunidad poderosa de manifestación. No necesitas inspiración para usarlo — él te la da.'
}, {
  id: 2,
  emoji: '🎵',
  title: '"Los Secretos de los Sonidos Mágicos"',
  value: 19,
  desc: 'Hay sonidos que el cerebro reconoce como señales de apertura y expansión. Descubre exactamente cuáles son, cómo usarlos en tu práctica diaria y cómo elevan tu vibración de forma inmediata — para que la manifestación fluya con menos resistencia y más velocidad.'
}, {
  id: 3,
  emoji: '🔢',
  title: '"Números Mágicos para una Vida Abundante"',
  value: 27,
  desc: 'Los números son el lenguaje con el que el universo se comunica contigo — todo el tiempo. Aprende a leer esas señales, a trabajar con códigos sagrados y secuencias numéricas para activar energías específicas de prosperidad, amor y transformación en tu vida cotidiana.'
}, {
  id: 4,
  emoji: '💎',
  title: '"El Poder de los Cristales"',
  value: 27,
  desc: 'Durante siglos, las culturas más sabias del mundo utilizaron los cristales como herramientas para limpiar energía, romper bloqueos profundos y abrir canales de abundancia. Descubre cómo usarlos tú también — aunque nunca hayas trabajado con cristales antes. Incluye ejercicios y rituales concretos que puedes aplicar desde el primer día.'
}, {
  id: 5,
  emoji: '🌑',
  title: '"El Poder de los Eclipses"',
  value: 20,
  desc: 'Los eclipses Lunares y Solares son los momentos de mayor intensidad energética del año — ventanas únicas para manifestar, cerrar ciclos y soltar lo que ya no te pertenece. Aprende cómo prepararte para cada eclipse con rituales específicos que amplifican tu intención al máximo y te permiten aprovechar cada uno de estos momentos cósmicos extraordinarios.'
}, {
  id: 6,
  emoji: '🌕',
  title: '"Rituales Lunares"',
  value: 20,
  desc: 'La Luna no es solo luz en la noche. Es tu aliada más constante en el arte de manifestar. Cada fase tiene un propósito sagrado: 🌑 Luna Nueva — Siembra tus intenciones más profundas. 🌒 Luna Creciente — Impulsa lo que quieres atraer. 🌕 Luna Llena — Celebra, amplifica y recibe. 🌘 Luna Menguante — Suelta, limpia y libera. Aprende a sincronizar tu vida con este ciclo natural.'
}];
export function BonusGrid() {
  return <section className="py-24 px-4 bg-brand-bg relative overflow-hidden" data-id="element-50">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-52">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-brand-rose/10 rounded-full mb-6" data-id="element-53">
            <Gift className="w-10 h-10 text-brand-rose" data-id="element-54" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-55">
            Y Eso No Es Todo...
          </h2>
          <p className="text-2xl md:text-3xl font-serif text-brand-plum mb-4" data-id="element-56">
            Al Adquirir Tu Libro HOY, Recibirás GRATIS Estos 6 Regalos Mágicos
          </p>
          <div className="inline-block bg-brand-gold/20 px-6 py-3 rounded-full border border-brand-gold/30" data-id="element-57">
            <p className="text-brand-plum font-bold text-lg" data-id="element-58">
              💰 Valor real de los bonos: $130 USD — Todos GRATIS hoy con tu
              compra
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-59">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-3xl p-8 shadow-lg border border-brand-rose/10 relative group hover:-translate-y-2 transition-transform duration-300" data-id="element-60">
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-brand-bgAlt rounded-full -z-10 group-hover:bg-brand-rose/10 transition-colors" data-id="element-61"></div>

              <div className="text-sm font-bold text-brand-rose tracking-widest mb-4 flex items-center gap-2" data-id="element-62">
                <Gift className="w-4 h-4" data-id="element-63" /> REGALO #{bonus.id}
              </div>

              <div className="text-5xl mb-6" data-id="element-64">{bonus.emoji}</div>

              <h3 className="text-2xl font-bold text-brand-plum mb-4 leading-tight" data-id="element-65">
                {bonus.title}
              </h3>

              <div className="bg-brand-rose/10 text-brand-rose font-bold px-4 py-2 rounded-lg inline-block mb-6 text-sm" data-id="element-66">
                Valor: ${bonus.value} USD — HOY GRATIS
              </div>

              <p className="text-brand-textLight leading-relaxed" data-id="element-67">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <CTAButton text="¡QUIERO EL LIBRO Y LOS 6 BONOS AHORA MISMO!" data-id="element-68" />
        <p className="text-center mt-4 text-brand-textLight font-medium" data-id="element-69">
          Acceso inmediato a todo el pack en tu correo electrónico
        </p>
      </div>
    </section>;
}